import React from 'react'
import './AlertMessageStyle.css'
import { Col, Modal, Row } from 'react-bootstrap'
import { Button } from '@components/common'

type AlertMessageProps = {
  show: boolean
  onHide: () => void
  title: string
  message: string
  type: 'success' | 'error'
}

const AlertMessage: React.FC<AlertMessageProps> = ({
  show,
  onHide,
  title,
  message,
  type,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="alert-message-modal">
      <Modal.Header className="bg-custom3" closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mt-2 appt-modal">
          {type === 'error' && (
            <Row style={{ margin: '100px 0' }}>
              <Col className="text-center">
                <i className="appt-failed mgc_close_circle_fill"></i>
                <p>{message}</p>
              </Col>
            </Row>
          )}

          {type === 'success' && (
            <Row style={{ margin: '100px 0' }}>
              <Col className="text-center">
                <i
                  className="ti ti-circle-check-filled"
                  style={{ fontSize: '120px', color: '#3E8E53' }}
                ></i>
                <p>{message}</p>
              </Col>
            </Row>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button size="md" className="button-primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AlertMessage
